import { IModuleProps } from '../../core/utils/modules';

export default {
    name: 'lutzgruppe',
} as IModuleProps;
